import LayoutNavigation from './navigation/LayoutNavigation';
import "./App.css"
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <LayoutNavigation />
    </div>
  );
}

export default App;
